import React from "react";
import AccountingSetupRoute from "./accounting-setup";
import AssetTypeRoute from "./asset-type";
import AssetRoute from "./assets";
import BankRoute from "./bank";
import BeginningBalanceRoute from "./beginning-balance";
import CashBankRoute from "./cash-bank";
import ClosebookRoute from "./closebook";
import Coa1Route from "./coa1";
import Coa2Route from "./coa2";
import Coa3Route from "./coa3";
import Coa4Route from "./coa4";
import Coa5Route from "./coa5";
import ConfigurationRoute from "./configuration";
import DownPaymentRoute from "./down-payment";
import JournalRoute from "./journal";
import ListPaymentRoute from "./list-payment";
import LogBgRoute from "./log-bg";
import MemoInRoute from "./memo-in";
import MemoOutRoute from "./memo-out";
import { Route } from "react-router-dom";
import BudgetRoute from "./budget";


export default function AccountingRoutes( props ) {
    return (
    <Route path="/accounting">
       {AccountingSetupRoute(props)}
       {AssetTypeRoute(props)}
       {AssetRoute(props)}
       {BankRoute(props)}
       {BeginningBalanceRoute(props)}
       {CashBankRoute(props)}
       {ClosebookRoute(props)}
       {Coa1Route(props)}
       {Coa2Route(props)}
       {Coa3Route(props)}
       {Coa4Route(props)}
       {Coa5Route(props)}
       {ConfigurationRoute(props)}
       {DownPaymentRoute(props)}
       {JournalRoute(props)}
       {ListPaymentRoute(props)}
       {LogBgRoute(props)}
       {MemoInRoute(props)}
       {MemoOutRoute(props)}
       {BudgetRoute(props)}
    </Route>
    )
}